import { render, staticRenderFns } from "./invited.vue?vue&type=template&id=9dd61faa&scoped=true&"
import script from "./invited.vue?vue&type=script&lang=js&"
export * from "./invited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd61faa",
  null
  
)

export default component.exports